/*
	Topic IDs mapped to expertise
*/
type ExpertiseTopicsMap = {
	[key: number]: number[];
};

export const MapExpertiseTopics: ExpertiseTopicsMap = {
	1: [26, 27, 30, 31, 32, 33, 34, 35],
	2: [30, 31, 32, 33, 34],
	3: [27, 34, 35],
	4: [34],
	5: [30, 31, 32, 33],
	6: [33],
	7: [33],
	8: [27, 28, 29, 30, 31, 32],
	9: [35],
	10: [29, 31, 35],
	11: [27, 28]
}